import React from 'react'
import { ActivityIndicator } from 'react-native'
import styled, { useTheme } from 'styled-components/native'

import I18n from 'APP/Services/i18n'

import Typography from 'APP/Converse/Typography'

const LoadingContainer = styled.View`
  background-color: ${({ theme }) => theme.colors.background};
  flex: 1;
  justify-content: center;
  align-items: center;
  min-height: 100%;
  gap: ${({ theme }) => theme.metrics.baseMargin*2}px;
`

const LoadingText = styled(Typography)`
  color: ${({ theme }) => theme.colors.text};
  align-items: 'baseline';
  text-align: 'center';
  ${({ theme }) => theme.fonts.styles.h2};
`

export const AccountLinkingLoadingScreen = () => {
  const theme = useTheme()

  return (
    <LoadingContainer testID="ACCOUNT_LINKING_LOADING_SCREEN">
      <LoadingText>{I18n.t('AccountLinkingScreen.loading.title')}</LoadingText>
      <ActivityIndicator size="large" color={theme.colors.text} />
    </LoadingContainer>
  )
}
